/**
 * Display-only labels for autocomplete categories. The API `CategoryName` (and
 * what we persist in recent searches) is unchanged — only the visible text differs.
 */
const CATEGORY_LABELS: Record<string, string> = {
  State: "USA",
}

export function getCategoryLabel(categoryName: string): string {
  return CATEGORY_LABELS[categoryName] ?? categoryName
}
